import Resizer from "react-image-file-resizer";
import { getWidthHeightFromSrc } from '@utils/userUtils';

export const getBase64 = (file: File) => {
    return new Promise<string | undefined>((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        if (reader.result) resolve(reader.result.toString())
        else resolve(undefined);
      };
      reader.onerror = function (error) {
        console.error(error);
        reject(error)
      };
    });
  }

  export const resizeImage = async (file: File, format: string, width: number, height: number, keepAspectRatio: boolean) => {
    let finalWidth = width;
    let finalHeight = height;
    console.log("ImageResize")
    console.log("height",height)
    console.log("widht",width)
    console.log("keepAspectRatio",keepAspectRatio)
    if (keepAspectRatio) {
        const srcFileOrg = await getBase64(file);
        const dimensionsOrg = await getWidthHeightFromSrc(srcFileOrg ?? "");
        console.log("dimensionOrg",dimensionsOrg)
        if (dimensionsOrg) {
            const factor1 = dimensionsOrg.width/width;
            console.log("factor1",factor1)
            if ((dimensionsOrg.height/factor1)>=height) {
                finalHeight = (dimensionsOrg.height/factor1);
                console.log("finalheight",finalHeight)
            }
            else {
                const factor2 = dimensionsOrg.height/height;
                finalWidth = (dimensionsOrg.width/factor2);
                console.log("finalwidth",finalWidth)
            }
        }
    }
    return new Promise<string | File | Blob | ProgressEvent<FileReader>>((resolve, reject) => {
        Resizer.imageFileResizer(
        file,
        finalWidth,
        finalHeight,
        format, //JPEG, PNG
        (format==="JPEG"?100:100),
        0,
        (uri) => {
            resolve(uri);
        },
        "base64"
        );
    });
  }

  export const reduceImageFileSize = async (file: File, format: string, maxFileSize: number, pixelResize: number) => {
    let totalPixelsResize = 0;
    let newFileBase64 = await getBase64(file);
    const dimensionsOrg = await getWidthHeightFromSrc(newFileBase64 ?? "");
    let nextPixelResize = (parseInt(((newFileBase64??"").length/maxFileSize).toString()) * pixelResize);
    while (dimensionsOrg!==undefined && dimensionsOrg.width>(totalPixelsResize + nextPixelResize) && dimensionsOrg.height>(totalPixelsResize + nextPixelResize) && (newFileBase64??"").length>maxFileSize) {
      totalPixelsResize += nextPixelResize;
      newFileBase64 = (await resizeImage(file, format, dimensionsOrg!.width - totalPixelsResize, dimensionsOrg!.height - totalPixelsResize, true)).toString();
      nextPixelResize = (parseInt(((newFileBase64??"").length/maxFileSize).toString()) * pixelResize);
    }
    return newFileBase64;
  }


